<form>
  <div mat-dialog-content [class]="getTheme()">

    <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'calibrateEquipmentEdit.asLeft.cols.point.label' | translate }}</mat-label>
          <input matInput [pattern]="numberRegexp" name="point"
            [(ngModel)]="data.item.point">
          <mat-error>
            {{ 'calibrateEquipmentEdit.asLeft.cols.point.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      @if (data.isParticle) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'alibrateEquipmentEdit.uncertainties.cols.particlesSize.label' | translate }}</mat-label>
            <input matInput name="particlesSize" [(ngModel)]="data.item.particlesSize">
          </mat-form-field>
        </div>
      }

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'calibrateEquipmentEdit.asLeft.cols.physical.label' | translate }}</mat-label>
          <input matInput [pattern]="numberRegexp" (blur)="onChangePattern()"
            name="pattern" [(ngModel)]="data.item.pattern">
          <mat-error>
            {{ 'calibrateEquipmentEdit.asLeft.cols.pattern.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'calibrateEquipmentEdit.asLeft.cols.correction.label' | translate }}</mat-label>
          <input matInput [pattern]="numberRegexp" name="correction" disabled [ngModel]="data.item.correction | number:'1.' + getDecimalsPattern(data.item.pattern) + '-' +
                getDecimalsPattern(data.item.pattern)">
          <mat-error>
            {{ 'calibrateEquipmentEdit.asLeft.cols.correction.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div fxFlex="50" fxFlex.lt-md="100%">
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'calibrateEquipmentEdit.uncertainties.cols.U.label' | translate }}</mat-label>
          <input type="number" matInput [pattern]="numberRegexp" name="uncertainty" [(ngModel)]="data.uncertainty">
          <mat-error>
            {{ 'calibrateEquipmentEdit.uncertainties.cols.U.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      @if (data.isBalance) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'alibrateEquipmentEdit.uncertainties.cols.idMass.label' | translate }}</mat-label>
            <input matInput name="idMass" [(ngModel)]="data.item.idMass">
          </mat-form-field>
        </div>
      }

      @if (data.isBalance) {
        <div fxFlex="50" fxFlex.lt-md="100%">
          <mat-checkbox name="annotation" [(ngModel)]="data.item.annotation">
            {{ 'calibrateEquipmentEdit.uncertainties.cols.annotation.label' | translate }}
          </mat-checkbox>
        </div>
      }

    </div>

  </div>
  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()"
    cdkFocusInitial>{{ 'button.save' | translate }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>